import React                from "react";
import {HBox}               from "@sirius/ui-lib/src/blocks/Layout";
import {block}              from "./block";
import {THeadProps}         from "./@types";

export const THead: React.FC<THeadProps> = ({
    el,
    width
}) =>
    <HBox className={ block.el('thead-wrapper') }>
        { el && React.cloneElement(el.props.children) }
    </HBox>
;
